module.exports = __webpack_public_path__ + "img/icon_map.449c870d.png";